module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reveal"
  }, [_c('div', {
    staticClass: "trigger-wrapper",
    attrs: {
      "data-open": _vm.uid
    }
  }, [_vm._t("trigger")], 2), _c('div', {
    staticClass: "reveal",
    attrs: {
      "id": _vm.uid,
      "data-reveal": ""
    }
  }, [_vm._t("default"), _vm._m(0), (_vm.confirm) ? _c('div', {
    staticClass: "confirm-buttons"
  }, [_c('button', {
    staticClass: "button success yes",
    attrs: {
      "data-close": ""
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Yes")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "data-close": ""
    }
  }, [_vm._v("No")])]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d3a41d7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/Reveal.vue
// module id = 2415
// module chunks = 1